import { getCurrentDate, getCurrentYear } from '@/helpers/currentDate';
import { getOriginUrl } from '@/helpers/currentUrl';

export const usingLanguagesForCitationSite = ['RU', 'ENG'];

function getTextOfSiteCitationInRu() {
  return `Цифровой гербарий Самарского университета (SMR) [Электронный ресурс]. Самара: Самарский университет,
        ${getCurrentYear()}. Режим доступа: ${getOriginUrl()}/ (дата обращения:
        ${getCurrentDate()}).`;
}

function getTextOfSiteCitationInEng() {
  return `Digital Herbarium of Samara University (SMR) [Electronic resource]. Samara: Samara University,
        ${getCurrentYear()}. Available at: ${getOriginUrl()}/ (accessed:
        ${getCurrentDate()}).`;
}

export function getTextOfSiteCitationByLanguage(lang = 'RU') {
  let targetText = '';

  switch (lang) {
    case 'RU':
      targetText = getTextOfSiteCitationInRu();
      break;
    case 'ENG':
      targetText = getTextOfSiteCitationInEng();
      break;
    default:
      targetText = getTextOfSiteCitationInRu();
  }

  return targetText;
}